<template>
  <v-row dense class="pa-0">
    <v-col class="pa-0" cols="12">
      <v-timeline v-for="(day, key) in transaction_days" :key="key" class="pa-0" test-id="transaction-events-timeline">
        <v-row dense>
          <v-timeline-item color="var(--primary-alternative)" hide-dot>
            <h2 test-id="title-timeline-events">
              {{ capitalize(dayjs.unix(day.day_at).format(const_global.DATE_TIME_FORMAT_E)) }}
            </h2>
          </v-timeline-item>
        </v-row>

        <v-row dense>
          <v-timeline-item v-for="(event, i) in day.events" :key="i" test-id="content-events-card"
            :icon="getEventIcon(event.key)" :icon-color="getEventColor(event.key)" class="pa-0 ma-0" fill-dot right>
            <v-list-item class="pa-0 ma-0">
             
                  <v-list-item-content class="pa-0 ma-0 text-wrap">
                    <v-list-item-title class="font-weight-medium text-wrap" test-id="title-events-card">
                      {{ capitalize(event.event) }}
                    </v-list-item-title>

                    <v-list-item-subtitle class="cts-font-size-4 text-wrap" test-id="subtitle-events-card">
                      {{ capitalize(event.subtitle) }}
                    </v-list-item-subtitle>

                    <span class="font-weight-medium grey--text text--darken-1" style="font-size: 12px;">
                      {{ dayjs.unix(event.event_at).format(const_global.DATE_TIME_FORMAT_C) }}
                    </span>
                  </v-list-item-content>
               
            </v-list-item>
          </v-timeline-item>
        </v-row>
      </v-timeline>
    </v-col>
  </v-row>
</template>

<script>
import const_icons from "@/constants/icons";
import const_global from "@/constants/global";

export default {
  name: "TransactionEventMobile",
  props: {
    capitalize: Function,
    transaction_days: Array,
    dayjs: Function,
    getEventIcon: Function,
    getEventColor: Function,
  },
  data() {
    return {
      const_icons,
      const_global,
    };
  },
};
</script>

<style lang="scss" scoped>
.transaction-view-container .transaction-events-container .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse)::before {
  left: 45px !important;
}

.v-list-item-subtitle {
  font-family: monospace;
  font-size: 12px;
}
.v-timeline-item {
  padding-left: 0 !important;
}

.v-timeline-item__body {
  margin-left: 0 !important;
  padding-left: 0 !important;
  width: 100%;
  overflow-wrap: break-word;
}
@media (max-width: 670px) {
  .transaction-view-container .transaction-events-container .v-timeline-item .v-timeline-item__body .v-list-item__content {
    width: 100% !important;
    min-width: 180px;
    max-width: 220px;
    padding-right:5px;
}
}
</style>

